const state = {
  count: 0
}

export default state



// WEBPACK FOOTER //
// ./client/store/state.js